import { PureComponent } from "react";
import PropTypes from "prop-types";

/**
 * 
 * @param {totalRecord} totalRecord total count of data
 * @param {onPageChange} onPageChange function when page changed
 * @param {lastPage} lastPage last page number
 * @param {pageSize} pageSize total data showed per page
 * @param {page} page current page number
 */
class CustomPaginator extends PureComponent {
    constructor(props) {
        super(props)
        this.state = {
            page: props.page,
            paginate_timeout: 0,
        };
    }

    nextPageData = () => {
        let page = parseInt(this.state.page)
        this.setState({
            page: page+1 > this.props.lastPage ? page : page+1
        }, () => this.props.onPageChange(this.state.page))
    }

    prevPageData = () => {
        let page = parseInt(this.state.page)
        this.setState({
            page: page-1 < 1 ? page : page-1
        }, () => this.props.onPageChange(this.state.page))
    }

    lastPageData = () => {
        let page = parseInt(this.state.page)
        this.setState({
            page: this.props.lastPage
        }, () => this.props.onPageChange(this.state.page))
    }

    jumpToPageData = (page) => {
        let self = this;

        if (self.state.paginate_timeout) {
           clearTimeout(self.state.paginate_timeout);
        }
        
        if (page < 1) {
            page = 1
        } else if (page > self.props.lastPage) {
            page = self.props.lastPage
        }

        self.setState({
            page: parseInt(page),
            paginate_timeout: setTimeout(function() {
                self.props.onPageChange(parseInt(page));
            }, 500)
        })
    }

    render() {
        return (
            <div className="position-absolute w-100 shadow-lg p-2" style={{bottom: 0}}>
                <div className="d-flex flex-row-reverse align-items-center">
                    <button
                        className="btn border-438EBC color-438EBC mx-2 font-weight-bold"
                        onClick={this.lastPageData}
                        disabled={this.state.page >= this.props.lastPage}
                    >Halaman Akhir</button>
                    <button
                        className="btn border-438EBC color-438EBC mx-2 font-weight-bold"
                        onClick={this.nextPageData}
                        disabled={this.state.page >= this.props.lastPage}
                    >Selanjutnya</button>
                    <span className="mx-2">dari {this.props.lastPage}</span>
                    <input
                        type="number"
                        min={1}
                        max={this.props.lastPage}
                        value={this.state.page}
                        className="mx-2"
                        style={{width: '50px'}}
                        onChange={(e) => this.jumpToPageData(e.target.value)}
                    />
                    <span className="mx-2">halaman</span>
                    <button
                        className="btn border-438EBC color-438EBC mx-2 font-weight-bold"
                        onClick={this.prevPageData}
                        disabled={this.state.page <= 1}
                    >Sebelumnya</button>
                    <span className="mx-2">{this.props.lastPage > 1 ? this.props.pageSize : this.props.totalRecord} dari {this.props.totalRecord} data</span>
                </div>
            </div>
        );
    }
}

CustomPaginator.propTypes = {
    totalRecord: PropTypes.number.isRequired,
    page: PropTypes.number.isRequired,
    lastPage: PropTypes.number.isRequired,
    pageSize: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
}

CustomPaginator.defaultProps = {
    totalRecord: 0,
    page: 1,
    lastPage: 1,
    pageSize: 10,
}

export default CustomPaginator;